// noinspection JSUnusedGlobalSymbols

import {ShoppingCart} from '../models/ShoppingCart';
import Debug from './Debug';

export default class Storage {
    static getFingerprint() {
        return localStorage.getItem('s&g_fingerprint');
    };

    static setFingerprint(fingerprint) {
        localStorage.setItem('s&g_fingerprint', fingerprint);
    };

    static removeFingerprint() {
        localStorage.removeItem('s&g_fingerprint');
    };

    static getSession() {
        return sessionStorage.getItem('s&g_session');
    };

    static setSession(session) {
        sessionStorage.setItem('s&g_session', session);
    };

    static removeSession() {
        sessionStorage.removeItem('s&g_session');
    };

    static getStore() {
        return localStorage.getItem('s&g_store');
    };

    static setStore(store) {
        localStorage.setItem('s&g_store', store);
    };

    static removeStore() {
        localStorage.removeItem('s&g_store');
    };

    static getBackupStores() {
        const value = localStorage.getItem('s&g_backup_stores');
        try {
            return value ? value.split(',') : [];
        } catch (error) {
            Debug.printToLog('error', `Invalid backup stores '${value}', reverting to default. ${error}`);
            return [];
        }
    };

    static getShoppingCart() {
        const data = localStorage.getItem('s&g_shopping_cart');
        if (!data) return undefined;
        try {
            return ShoppingCart.fromStorage(JSON.parse(data));
        } catch (error) {
            Debug.printToLog('error', `Invalid shopping cart '${data}', reverting to default. ${error}`);
            return undefined;
        }
    };

    static setShoppingCart(shoppingCart) {
        localStorage.setItem('s&g_shopping_cart', JSON.stringify(shoppingCart.toStorage()));
    };

    static removeShoppingCart() {
        localStorage.removeItem('s&g_shopping_cart');
    };
}